import React from 'react';
import { AuthPage } from '../auth/auth-page';

export const Register = () => <AuthPage view="register" />;
